import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToAnchorPost } from 'shared/utils/scrollToAnchorPost';

const INITIAL_CHUNK = 1;
const CHUNK = 2;
const PRELOAD_MARGIN = 1200;
const EXPAND_COOLDOWN = 400;
const PAGING_LIMIT = 30;
const FULL_PAGING_LIMIT = 300;

type Theme = { longreadId?: string };
type PostRef = { postId?: string; longreadId?: string };

interface UseLazyModuleThemesParams<T extends Theme> {
  themes: T[];
  allLongreadPosts?: PostRef[] | null;
  resetKey?: string;
}

export const useLazyModuleThemes = <T extends Theme>({
  themes,
  allLongreadPosts,
  resetKey,
}: UseLazyModuleThemesParams<T>) => {
  const location = useLocation();

  const [visibleCount, setVisibleCount] = useState(INITIAL_CHUNK);
  const [fullyRenderedThemeIds, setFullyRenderedThemeIds] = useState<Set<string>>(() => new Set());
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setVisibleCount(INITIAL_CHUNK);
    setFullyRenderedThemeIds(new Set());
  }, [resetKey]);

  const hasMore = visibleCount < themes.length;

  useEffect(() => {
    if (!hasMore) return;

    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    const check = () => {
      const node = sentinelRef.current;
      if (timeoutId || !node) return;
      if (node.getBoundingClientRect().top > window.innerHeight + PRELOAD_MARGIN) return;

      timeoutId = setTimeout(
        () => setVisibleCount((prev) => Math.min(prev + CHUNK, themes.length)),
        EXPAND_COOLDOWN,
      );
    };

    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);

    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [hasMore, themes.length, visibleCount]);

  const postToLongread = useMemo(() => {
    const map = new Map<string, string>();
    (allLongreadPosts || []).forEach((post) => {
      if (post?.postId && post?.longreadId) map.set(post.postId, post.longreadId);
    });
    return map;
  }, [allLongreadPosts]);

  const expandToPost = useCallback((postId?: string) => {
    const targetId = postId ? postToLongread.get(postId) : undefined;
    if (!targetId) return;

    const index = themes.findIndex((theme) => theme?.longreadId === targetId);
    if (index < 0) return;

    setVisibleCount((prev) => Math.max(prev, index + 1));
    setFullyRenderedThemeIds((prev) => {
      if (prev.has(targetId)) return prev;
      const next = new Set(prev);
      next.add(targetId);
      return next;
    });
  }, [themes, postToLongread]);

  const scrolledHashRef = useRef<string | null>(null);

  useEffect(() => {
    const postId = location?.hash?.replace('#', '');
    if (!postId) return;

    expandToPost(postId);

    if (scrolledHashRef.current === postId) return;
    scrolledHashRef.current = postId;
    scrollToAnchorPost(postId);
  }, [location?.hash, expandToPost]);

  const visibleThemes = useMemo(() => themes.slice(0, visibleCount), [themes, visibleCount]);

  const getThemePagingLimit = useCallback(
    (longreadId?: string) =>
      longreadId && fullyRenderedThemeIds.has(longreadId) ? FULL_PAGING_LIMIT : PAGING_LIMIT,
    [fullyRenderedThemeIds],
  );

  return { visibleThemes, hasMore, sentinelRef, getThemePagingLimit };
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToAnchorPost } from 'shared/utils/scrollToAnchorPost';

const INITIAL_CHUNK = 1;
const CHUNK = 2;
const PRELOAD_MARGIN = 1200;
const EXPAND_COOLDOWN = 400;
const PAGING_LIMIT = 30;
const FULL_PAGING_LIMIT = 300;

type Theme = { longreadId?: string };
type PostRef = { postId?: string; longreadId?: string };

interface UseLazyModuleThemesParams<T extends Theme> {
  themes: T[];
  allLongreadPosts?: PostRef[] | null;
  resetKey?: string;
}

export const useLazyModuleThemes = <T extends Theme>({
  themes,
  allLongreadPosts,
  resetKey,
}: UseLazyModuleThemesParams<T>) => {
  const location = useLocation();

  const [visibleCount, setVisibleCount] = useState(INITIAL_CHUNK);
  const [fullyRenderedThemeIds, setFullyRenderedThemeIds] = useState<Set<string>>(() => new Set());
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setVisibleCount(INITIAL_CHUNK);
    setFullyRenderedThemeIds(new Set());
  }, [resetKey]);

  const hasMore = visibleCount < themes.length;

  useEffect(() => {
    if (!hasMore) return;

    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    const check = () => {
      const node = sentinelRef.current;
      if (timeoutId || !node) return;
      if (node.getBoundingClientRect().top > window.innerHeight + PRELOAD_MARGIN) return;

      timeoutId = setTimeout(
        () => setVisibleCount((prev) => Math.min(prev + CHUNK, themes.length)),
        EXPAND_COOLDOWN,
      );
    };

    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);

    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [hasMore, themes.length, visibleCount]);

  const postToLongread = useMemo(() => {
    const map = new Map<string, string>();
    (allLongreadPosts || []).forEach((post) => {
      if (post?.postId && post?.longreadId) map.set(post.postId, post.longreadId);
    });
    return map;
  }, [allLongreadPosts]);

  const expandToPost = useCallback((postId?: string) => {
    const targetId = postId ? postToLongread.get(postId) : undefined;
    if (!targetId) return;

    const index = themes.findIndex((theme) => theme?.longreadId === targetId);
    if (index < 0) return;

    setVisibleCount((prev) => Math.max(prev, index + 1));
    setFullyRenderedThemeIds((prev) => {
      if (prev.has(targetId)) return prev;
      const next = new Set(prev);
      next.add(targetId);
      return next;
    });
  }, [themes, postToLongread]);

  const scrolledHashRef = useRef<string | null>(null);

  useEffect(() => {
    const postId = location?.hash?.replace('#', '');
    if (!postId) return;

    expandToPost(postId);

    if (scrolledHashRef.current === postId) return;
    scrolledHashRef.current = postId;
    scrollToAnchorPost(postId);
  }, [location?.hash, expandToPost]);

  const visibleThemes = useMemo(() => themes.slice(0, visibleCount), [themes, visibleCount]);

  const getThemePagingLimit = useCallback(
    (longreadId?: string) =>
      longreadId && fullyRenderedThemeIds.has(longreadId) ? FULL_PAGING_LIMIT : PAGING_LIMIT,
    [fullyRenderedThemeIds],
  );

  return { visibleThemes, hasMore, sentinelRef, getThemePagingLimit };
};
